import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import { stripHtml } from 'string-strip-html';

export const HighlightText = ({ textString, highlightString }) => {
  if (!textString || !highlightString) {
    return textString;
  }

  const searchText = new RegExp(highlightString, 'gi');
  const textPieces = textString.split(searchText);
  const highlightPieces = textString.match(searchText);

  if (textPieces.length <= 1) {
    return textString;
  }

  return (
    <>
      {textPieces.map((piece, index) => {
        return (
          // eslint-disable-next-line react/no-array-index-key
          <Fragment key={`${textString}_piece_${index}`}>
            {piece}
            {index < textPieces.length - 1 && <em className="highlighted">{highlightPieces[index]}</em>}
          </Fragment>
        );
      })}
    </>
  );
};

HighlightText.propTypes = {
  textString: PropTypes.string,
  highlightString: PropTypes.string
};

export const HighlightSnippet = ({ textString, highlightString, maxCharsBefore = 50, maxCharsAfter = 50 }) => {
  if (!textString) {
    return null;
  }

  const lowerCasedHighlightString = highlightString.toLocaleLowerCase();

  const snippetAsTextOnly = stripHtml(textString).result;

  const lowerCasedSnippetAsTextOnly = snippetAsTextOnly.toLocaleLowerCase();

  const firstPieceIndex = lowerCasedSnippetAsTextOnly.indexOf(lowerCasedHighlightString);

  if (firstPieceIndex < 0) {
    return snippetAsTextOnly.substring(0, maxCharsBefore + maxCharsAfter);
  }

  const startPiece = lowerCasedSnippetAsTextOnly.substring(0, firstPieceIndex);
  const endPiece = lowerCasedSnippetAsTextOnly.substring(firstPieceIndex + lowerCasedHighlightString.length);

  const startIsCropped = startPiece.length > maxCharsBefore;
  const endIsCropped = endPiece.length > maxCharsAfter;

  const startString = startIsCropped ? `...${startPiece.substring(startPiece.length - maxCharsBefore)}` : startPiece;

  const endString = endIsCropped ? `${endPiece.substring(0, maxCharsAfter)}...` : endPiece;

  return (
    <>
      {startString}
      <em className="highlighted">{highlightString}</em>
      {endString}
    </>
  );
};

HighlightSnippet.propTypes = {
  textString: PropTypes.string,
  highlightString: PropTypes.string,
  maxCharsBefore: PropTypes.number,
  maxCharsAfter: PropTypes.number
};
